<template>
  <label class="file-select">
    <div
      class="btn btn-secondary"
      v-tooltip="{ content: $t('upload_chart_config'), placement: 'top-center' }"
    >
      <i class="fas fa-upload"></i>
    </div>
    <input type="file" @change="handleFileChange" />
  </label>
</template>

<script>
export default {
  props: {
    value: File,
  },
  methods: {
    handleFileChange(ev) {
      if (ev.target.files[0].type.indexOf('json') > -1) {
        const file = ev.target.files[0]
        const reader = new FileReader()

        reader.onload = e => this.$emit('loadConfig', e.target.result)
        reader.readAsText(file)
      }
    },
  },
}
</script>

<style scoped>
.file-select > .select-button {
  padding: 1rem;

  color: white;
  background-color: #2ea169;

  border-radius: 0.3rem;

  text-align: center;
  font-weight: bold;
}

/* Don't forget to hide the original file input! */
.file-select > input[type='file'] {
  display: none;
}
</style>
